import { render, staticRenderFns } from "./CountryInfoDetail.vue?vue&type=template&id=342bc273&"
import script from "./CountryInfoDetail.vue?vue&type=script&lang=js&"
export * from "./CountryInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./CountryInfoDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports